/*
    Flat turf - race_type_code = F
    AW - race_type_code = X
    NHF - race_type_code = B & W
    Hurdle - race_type_code = H, Y
    Chase - race_type_code = C, U, Z
    PTP - race_type_code = P
    Rules Races - race_type_code != P
    A Stakes race will be any race that has
    race_group_uid = 1,2,3,4,5,7,8,9,11,12,13,14,15,16
*/
import filterArrays from '../filterArrays';

const stakesGroupIds = [1, 2, 3, 4, 5, 7, 8, 9, 11, 12, 13, 14, 15, 16];

const filterFuncs = {
    'Rules Races': ({ raceTypeCode }) => raceTypeCode && raceTypeCode !== 'P',
    Stakes: ({ raceGroupUid }) => stakesGroupIds.includes(raceGroupUid),
};

const getSortFn = (name) => {
    if (filterArrays[name]) {
        return ({ raceTypeCode }) => filterArrays[name].includes(raceTypeCode);
    }

    if (filterFuncs[name]) {
        return filterFuncs[name];
    }

    return () => true;
};

export default getSortFn;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/getSortFn.js